import { format } from 'date-fns';
import { es } from 'date-fns/esm/locale';
// eslint-disable-next-line no-unused-vars
import { DD_MMM_YY } from 'constants/date';
import { EVENTS_WAP } from 'constants/values/giftTableWap';
import { fixDate } from 'util/date';

export const giftTableTransformer = (giftTable = []) => {
  const transformedGiftTable = giftTable.map((gift) => {
    let fecha = '';
    const date = gift.event_date || gift.date;

    if (date) {
      // eslint-disable-next-line no-shadow
      const fixDate = date === '0000-00-00 00:00:00' ? '1900-01-01 00:00:00' : date;
      const eventDate = new Date(fixDate.replace(' ', 'T'));
      const formattedEventDate = format(eventDate, 'dd/MMM/yy', { locale: es });

      fecha = formattedEventDate.toUpperCase();
    }
    const festejados = gift.celebrate_labels?.map(c => c.label.value.trim());
    const otro = gift.other_event_name ? `(${gift.other_event_name})` : '';
    const tipo = gift.event_name || gift.type_name || '';

    return {
      fecha,
      evento: gift.gift_table_id || gift.id || '',
      // tipo: `${tipo} ${otro}`,
      tipo,
      plan: gift.plan_name || '',
      nombre: gift.git_table_name || gift.name || '',
      estatus: gift.status || '',
      festejados: festejados ? festejados.join(' & ') : '',
    };
  });

  return transformedGiftTable;
};

export const giftTableTransformerWap = (giftTable = {}) => {
  if(Array.isArray(giftTable) && !giftTable.length) {
    return null;
  }

  const transformedGiftTable = giftTable.events.map((gift) => {
    let fecha = '';
    const date = gift.fechaEvento;

    if (date) {
      const eventDate = new Date(`${fixDate(date)}T00:00:00`);
      const formattedEventDate = format(eventDate, 'dd/MMM/yy', { locale: es });
      fecha = formattedEventDate.toUpperCase();
    }
    const festejados = gift.nombre2.length ? `${gift.nombre1} & ${gift.nombre2}` : gift.nombre1;
    const tipo = EVENTS_WAP[gift.tipo].name;

    return {
      fecha,
      tipo,
      festejados,
      evento: gift.numEvento || '',
      isWap: true
    };
  });

  return transformedGiftTable;
};

export const transformProductCart = (product, hasDelete = false) => ({
  product_sears_id: product.id,
  variant_sears_id: product.variant_id || product.variant_sears_id,
  children_sku_sears: product.children_sku_sears || product.variant_sku,
  sku: product.sku,
  ean: product.ean,
  quantity: product.quantity || (hasDelete ? 0 : 1),
  division_sears_id: product.division,
  is_market_place: !!(product.categories.length
    && product.categories[0].filter(c => c.seo === 'marketplace').length),
  category_sears_ids: product.categories?.length ? product.categories[0].map(i => i.id) : [1],
});